import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notification, getNotificationInput, NotificationType } from '../models/notifications.model';

const GET_NOTIFICATIONS_QUERY = gql`query getNotifications($Input: getNotificationInput!) {
  getNotifications(Input: $Input) {
    Id,
    Title,
    Description,
    Category,
    StartTime,
    EndTime,
    Severity,
    Type
  }
}`;

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(
    private getNotificationsGQL: getNotificationsGQL,
    private getNotificationsPublicGQL: getNotificationsPublicGQL
) { }

  private fetchNotifications(
    source: { fetch: (variables: { Input: getNotificationInput }) => Observable<{ data: { getNotifications: Notification[] | Notification | null | undefined } }> },
    input: getNotificationInput
  ): Observable<Notification[]> {
    const payload = { Input: input };
    return source.fetch(payload).pipe(
      map(result => {
        const data = result?.data?.getNotifications as Notification[] | Notification | null | undefined;
        if (Array.isArray(data)) return data;
        return data ? [data] : [];
      })
    );
  }

  // Private API: requires authentication
  getNotifications(input: getNotificationInput): Observable<Notification[]> {
    return this.fetchNotifications(this.getNotificationsGQL, input);
  }

  // Public API: uses x-api-key
  getNotificationsPublic(input: getNotificationInput): Observable<Notification[]> {
    return this.fetchNotifications(this.getNotificationsPublicGQL, input);
  }
}

@Injectable({ providedIn: 'root' })
class getNotificationsGQL extends Query<{ getNotifications: Notification[] | Notification }> {
  client = 'ovsAppSyncAuth';
  document = GET_NOTIFICATIONS_QUERY;
}

@Injectable({ providedIn: 'root' })
class getNotificationsPublicGQL extends Query<{ getNotifications: Notification[] | Notification }> {
  client = 'ovsAppSyncPublic';
  document = GET_NOTIFICATIONS_QUERY;
}
